import { SxProp } from 'src/types/mui';

import { spacingStyling } from './spacing';

export const searchFieldStyles: SxProp = {
  width: '290px',
};

export const pageLayoutPaperSx: SxProp = {
  p: spacingStyling.allTables,
  mt: 3,
};

export const topInTableWithBorderStyles: SxProp = theme => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  borderBottom: `1px solid ${theme.palette.border?.main}`,
  paddingBottom: '16px',
  gap: '14px',
});
